/**
 * TanStack Query hooks for the ledger feature. Keys are namespaced "ledger/…".
 * The chart of accounts is drained whole rather than paged, because a tree
 * drawn one page at a time is not a tree — see `listAccounts`.
 */
import { useQuery } from "@tanstack/react-query";

import { listAccounts, type Account, type AccountListQuery } from "./api";

export const ledgerKeys = {
  accounts: {
    all: ["ledger/accounts"] as const,
    list: (query: AccountListQuery) => ["ledger/accounts", "list", query] as const,
  },
  fxRates: {
    all: ["ledger/fx-rates"] as const,
    list: (filters: Record<string, unknown>) => ["ledger/fx-rates", "list", filters] as const,
  },
  fiscalYears: { all: ["ledger/fiscal-years"] as const },
  trialBalance: (periodId: string, currency: string, includeZero: boolean) =>
    ["ledger/trial-balance", periodId, currency, includeZero] as const,
};

export function useAccounts(query: AccountListQuery = {}, enabled = true) {
  return useQuery<Account[]>({
    queryKey: ledgerKeys.accounts.list(query),
    queryFn: ({ signal }) => listAccounts(query, signal),
    enabled,
  });
}
